<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <v-dialog :fullscreen="isMobile" width="820" v-model="internalDialog" scrollable>
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title>CHỈNH SỬA CÔNG VIỆC</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark>
          <v-icon @click="close">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />

      <v-card-text>
        <v-form class="mb-2 mt-8" ref="form" lazy-validation>
          <v-row>
            <v-col class="pb-0" cols="6">
              <v-text-field
                class="required"
                v-model="form.title"
                label="Tên công việc"
                :rules="[$rules.required]"
                required
                dense
                :disabled="!isCreator()"
                outlined
              />
            </v-col>
            <v-col class="pb-0" cols="6">
              <v-select
                v-model="form.status"
                :items="statusOptionsForUser"
                item-value="value"
                item-text="text"
                label="Trạng thái"
                class="required"
                :rules="[$rules.required]"
                dense
                outlined
                clearable
              >
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item v-bind="attrs" v-on="on">
                    <v-list-item-content>
                      <v-list-item-title :style="{ color: item.color }">
                        {{ item.text }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>

                <template v-slot:selection="{ item }">
                  <span :style="{ color: item.color }">{{ item.text }}</span>
                </template>
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0" cols="12">
              <AutocompleteExcludeTask
                :syncedValue.sync="form.receivers"
                item-text="name"
                clear-icon="mdi-close"
                outlined
                dense
                :rules="[$rules.required]"
                class="mb-2 required"
                deletable-chips
                label="Người nhận việc"
                hide-details
                :displaySubjectGroup="true"
                multiple
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0" cols="6">
              <DateIOSPicker
                :date.sync="form.due_date"
                label="Hạn hoàn thành"
                :key="form.id"
                dense
                outlined
                class="required"
                :disabled="!isCreator()"
                clearable
                :rules="[$rules.required, $rules.date]"
              />
            </v-col>
            <v-col class="pb-0" cols="6">
              <v-select
                v-model="form.priority"
                :items="priorities"
                item-value="value"
                item-text="text"
                label="Mức ưu tiên"
                class="required"
                dense
                :disabled="!isCreator()"
                outlined
                clearable
                :rules="[$rules.required]"
              >
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item v-bind="attrs" v-on="on">
                    <v-list-item-content>
                      <v-list-item-title :style="{ color: item.color }">
                        {{ item.text }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>

                <template v-slot:selection="{ item }">
                  <span :style="{ color: item.color }">
                    {{ item.text }}
                  </span>
                </template>
              </v-select>
            </v-col>
          </v-row>
          <vue-editor
            class="my-6"
            v-model="form.description"
            outline
            :editorOptions="editorOptions"
            :editorToolbar="[
              [{ header: [1, 2, false] }],
              ['bold', 'italic', 'underline'],
              [{ color: [] }, { background: [] }],
              ['link', 'image', 'video'],
              [{ align: [] }],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ indent: '-1' }, { indent: '+1' }],
              ['clean'],
            ]"
          />
          <div class="text-right text-caption mt-1">
            <span :class="{ 'red--text': descriptionLength > 500 }">
              {{ descriptionLength }} / 500 ký tự giới hạn
            </span>
          </div>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn class="text-none text-uppercase" outlined @click="close">Huỷ</v-btn>
        <v-btn color="primary text-none text-uppercase" elevation="0" @click="submit" :loading="loading">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AutocompleteExcludeTask from '@/components/basic/input/AutocompleteExcludeTask'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
import { VueEditor } from 'vue2-editor'
import { mapGetters } from 'vuex'

export default {
  props: {
    dialog: Boolean,
    task: Object,
  },
  components: {
    VueEditor,
    DateIOSPicker,
    AutocompleteExcludeTask,
  },
  data() {
    return {
      internalDialog: false,
      isMobile: false,
      valid: true,
      form: {
        id: '',
        status: '',
        title: '',
        description: '',
        receivers: [],
        due_date: '',
        priority: null,
        hashtag: '',
        note: '',
        evaluation: '',
      },
      loading: false,
      statusOptions: [
        { text: 'Chưa bắt đầu', value: 'not_started', color: 'grey' },
        { text: 'Đang thực hiện', value: 'in_progress', color: 'orange' },
        { text: 'Hoàn thành', value: 'completed', color: 'green' },
        { text: 'Chờ đánh giá', value: 'waiting', color: 'red' },
      ],
      priorities: [
        { value: 0, text: 'Khẩn cấp', color: 'red' },
        { value: 1, text: 'Cao', color: 'orange' },
        { value: 2, text: 'Bình thường', color: '#c09000' },
        { value: 3, text: 'Thấp', color: 'blue' },
        { value: 4, text: 'Rất thấp', color: 'grey' },
      ],

      editorOptions: {
        placeholder: 'Nhập mô tả công việc (tối đa 1000 ký tự)...',
      },
    }
  },
  computed: {
    ...mapGetters('auth', ['user']),
    statusOptionsForUser() {
      const status = this.task.status
      const isReceiver = this.isReceiver()
      const isCreator = this.isCreator()
      if (isCreator && status === 'waiting') {
        return this.statusOptions.filter(s => ['waiting', 'completed', 'in_progress'].includes(s.value))
      }
      if (isReceiver) {
        if (status === 'not_started') {
          return this.statusOptions.filter(s => ['not_started', 'in_progress', 'waiting'].includes(s.value))
        }
        if (status === 'in_progress') {
          return this.statusOptions.filter(s => ['in_progress', 'waiting'].includes(s.value))
        }
      }
      return this.statusOptions.filter(s => [status].includes(s.value))
    },
    descriptionLength() {
      var text = (this.form.description && this.form.description.replace(/<[^>]*>/g, '')) || ''
      return text.trim().length
    },
    isDescriptionTooLong() {
      return this.descriptionLength > 500
    },
  },
  created() {
    this.internalDialog = this.dialog
    this.$nextTick(() => this.initForm())
  },
  methods: {
    close() {
      this.internalDialog = false
    },
    isCreator() {
      if (!this.task || !this.user) return false
      return this.task.creatorData.user_id === this.user.id
    },

    isReceiver() {
      if (!this.task || !this.user) return false
      return (this.task.receiversData || []).some(r => r.user_id === this.user.id)
    },
    initForm() {
      if (this.task && this.task._id) {
        this.resetForm()
        this.form = {
          id: this.task._id || '',
          status: this.task.status || '',
          title: this.task.title || '',
          description: this.task.description || '',
          receivers: (this.task.receiversData || []).map(r => ({
            ...r,
            _id: r.user_id,
          })),
          due_date: this.task.due_date,
          priority: this.task.priority || null,
          hashtag: this.task.hashtag || '',
          note: this.task.note || '',
        }
      }
    },
    async submit() {
      if (!this.$refs.form.validate()) return
      if (this.isDescriptionTooLong) {
        this.$alert.error('Mô tả công việc vượt quá 500 ký tự.')
        return
      }
      this.loading = true
      try {
        const payload = {
          status: this.form.status,
          id: this.form.id,
          title: this.form.title,
          description: this.form.description,
          due_date: this.form.due_date,
          priority: this.form.priority,
          hashtag: this.form.hashtag,
          note: this.form.note,
          evaluation: this.form.status == 'completed' ? this.form.evaluation : null,
          receivers: this.form.receivers.map(user => ({
            name: user.name,
            user_id: user._id,
            role_id: user.group_id || '',
            role_name: user.group || '',
          })),
          currentStatus: this.task.status,
        }
        const res = await this.$store.dispatch('tasknew/updateTask', payload)
        if (res) {
          this.$alert.success('Cập nhật công việc thành công!')
          this.$emit('updated')
          this.close()
        } else {
          this.$alert.error('Cập nhật công việc thất bại')
        }
      } catch (err) {
        console.error('Lỗi submit:', err)
        this.$alert.error('Cập nhật công việc thất bại')
      } finally {
        this.loading = false
      }
    },
    onResize() {
      if (window.innerWidth < 600) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    resetForm() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    statusText(status) {
      const map = {
        not_started: 'Chưa bắt đầu',
        in_progress: 'Đang thực hiện',
        completed: 'Hoàn thành',
        waiting: 'Chờ đánh giá',
      }
      return map[status] || '-'
    },
    statusColor(status) {
      const map = {
        not_started: 'grey',
        in_progress: 'orange',
        completed: 'green',
        waiting: 'red',
      }
      return map[status] || 'grey'
    },
  },
  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  beforeDestroy() {
    if (typeof window === 'undefined') return
    window.removeEventListener('resize', this.onResize, { passive: true })
  },
  watch: {
    dialog: {
      immediate: true,
      handler(val) {
        this.internalDialog = val
      },
    },
    internalDialog(val) {
      if (!val) this.$emit('close')
    },
  },
}
</script>

<style scoped>
.v-data-footer {
  flex-wrap: nowrap;
}

.v-data-footer__icons-before {
  order: -1;
}
</style>
